const cart = document.querySelector('.js-cart');

// let less = document.querySelector('.js-less'),
//     more = document.querySelector('.js-more');


// if (less) {
//   less.addEventListener('click', (event) => {
//       event.preventDefault();
//       let val = document.querySelector('.js-qty').value;
//       console.log(val);
//
//       if (val > 1) {
//         document.querySelector('.js-qty').value = Number(document.querySelector('.js-qty').value) - 1;
//       }
//   });
// }

// if (more) {
//   more.addEventListener('click', (event) => {
//       event.preventDefault();
//       console.log('clicked');
//
//       let val = document.querySelector('.js-qty').value;
//       let max = document.querySelector('.js-qty').max;
//       console.log(val);
//
//       if (max.length && val < max) {
//         document.querySelector('.js-qty').value = Number(document.querySelector('.js-qty').value) + 1;
//       } else if (max.length && val == max) {
//         console.log('at max');
//       } else {
//         document.querySelector('.js-qty').value = Number(document.querySelector('.js-qty').value) + 1;
//       }
//   });
// }

function addToCart(elem) {

    elem = this;

    let id = this.dataset.id,
        qty = 1;

    let data = {
        id: id,
        quantity: qty
    }

    const cartCount = document.querySelectorAll('.js-cart-count');
    elem.classList.add('loading');

    console.log(elem);

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function () {

            $.getJSON('/cart.js', function (cart) {
                cartCount.forEach((elem) => {
                    elem.textContent = cart.item_count;
                });
            });

            elem.classList.remove('loading');

            updateCart();

        },
        error: function (e) {
            console.log('error: ', e);
        }

    });

};

function addAllToCart(elem) {
  console.log('add all to cart');

  elem = this;

  let array = this.dataset.array;

  array = JSON.parse(array);

  // console.log(array);

  const product_data = array.map(variantId => {
    return { quantity: 1, id: variantId }
  });

  console.log(product_data);


  let data = {
    items: product_data
  }

  const cartCount = document.querySelectorAll('.js-cart-count');
  elem.classList.add('loading');

  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function () {

          $.getJSON('/cart.js', function (cart) {
              cartCount.forEach((elem) => {
                  elem.textContent = cart.item_count;
              });
          });

          elem.classList.remove('loading');

          window.location.assign('/cart');

      },
      error: function (e) {
          console.log('error: ', e);
      }

  });

};

var add_all_to_cart = document.querySelectorAll('.js-add-all-to-cart');

if (add_all_to_cart) {
  for (var i = 0; i < add_all_to_cart.length; i++) {
    var current = add_all_to_cart[i];
    current.addEventListener('click', addAllToCart, false);
  }
}

var add_to_cart = document.querySelectorAll('.js-add-to-cart');
for (var i = 0; i < add_to_cart.length; i++) {
    var current = add_to_cart[i];
    current.addEventListener('click', addToCart, false);
}

function updateCart() {

    let $html = [];

    const cartItems = document.querySelector('.js-cart-items'),
        cartTotal = document.querySelector('.js-cart-total'),
        cartCount = document.querySelectorAll('.js-cart-count'),
        cartPromo = document.querySelector('.js-cart-promo'),
        cartButtons = [...document.querySelectorAll('.js-add-to-cart')];

    $.ajax({
        type: 'GET',
        url: '/cart?view=data.json',
        success: function (data) {

          let json_response = JSON.parse(data);

          let subtotal = json_response.subtotal;

          let hasMembership = false;

          Array.prototype.forEach.call(json_response.items, function (item, index) {

              console.log(item);

              let id = item.id,
                  url = item.url,
                  image = item.image,
                  alt = item.alt,
                  title = item.title,
                  variant = '',
                  quantity = item.quantity,
                  money = item.subtotal;

                if (item.variant !== "Default Title") {
                  variant = item.variant;
                }

                if (quantity > 0 && quantity < 10) {
                  quantity = '0' + quantity;
                }

                if (item.tags.includes('inveterate-product')){
                  hasMembership = true
                }

              let $item = `
              <div class="cart__item js-item" data-id="${ id }">
                  <a class="cart__item-image" href="${ url }">
                      <img loading="lazy" src="${ image }"
                          alt="${ alt }" />
                  </a>
                  <div class="cart__item-details">
                      <a class="cart__item-title" href="${ url }">
                        <span class="item-title__product">${ title }</span>
                        <span class="cart__item-price">${ money }</span>
                      </a>

                      <div class="cart__item-adjusters">
                        <button class="btn btn--secondary cart__item-remove js-remove-item" data-id="${ id }">
                          <span>remove</span>
                          <div class="spinner" data-loader>
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20"><path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="currentColor"/></svg>
                          </div>
                        </button>
                      </div>
                  </div>
              </div>
            `;

              $html.push($item);

          });
          const membershipModule = document.querySelector('[data-membership-module]');
          if (membershipModule) {
            if (hasMembership) {
              membershipModule.classList.add('hidden')
            } else {
              membershipModule.classList.remove('hidden')
            }
          }
          
          cartButtons.forEach((btn) => {
            const newButton = document.createElement('a');
            newButton.setAttribute('href', "/cart");
            newButton.setAttribute('class', "btn");

            newButton.innerHTML = '<span>View Cart</span>';
            btn.replaceWith(newButton)
          })

          if (cartItems) {
            cartItems.innerHTML = $html.join('');
          }

          if (cartTotal) {
            cartTotal.innerText = subtotal;
          }

          cartCount.forEach((cart) => {
            cart.innerText = json_response.count;
          });

          // console.log(json_response.count);

        },
        error: function (status) {
          console.warn('ERROR', status);
        }
    });
}


// function updateQuantity(elem) {
//
//     if (elem.classList.contains('less')) {
//
//         let input = elem.nextElementSibling;
//         input.value--;
//
//         let qty = input.value,
//             id = input.dataset.id;
//
//         $.post('/cart/change.js', {
//                     quantity: qty,
//                     id: id
//                 },
//                 null,
//                 "json"
//             )
//             .done(function () {
//                 updateCart();
//             });
//
//     } else if (elem.classList.contains('more')) {
//
//         let input = elem.previousElementSibling;
//         input.value++;
//
//         let qty = input.value,
//             id = input.dataset.id;
//
//         console.log(id);
//
//         $.post('/cart/change.js', {
//                     quantity: qty,
//                     id: id
//                 },
//                 null,
//                 "json"
//             )
//             .done(function () {
//                 console.log('test?');
//                 updateCart();
//             });
//
//     }
// }

function removeItem(elem) {

    let id = elem.dataset.id;
    elem.classList.add('loading');

    $.post('/cart/change.js', {
                quantity: 0,
                id: id
            },
            null,
            "json"
        )
        .done(function () {
          elem.classList.remove('loading');

            updateCart();
        });

}

function hasClass(elem, className) {
  if (className && className.includes(' ')) {
    return elem.className.split(' ').indexOf(className) > -1;
  } else if (className) {
    return elem.className == className;
  }
}

document.addEventListener('click', function (e) {
    if (e.target.classList.contains('js-remove-item')) {
        removeItem(e.target);
    } else if (e.target.classList.contains('js-update-qty')) {
        updateQuantity(e.target);
    }
}, false);
